module.exports = __webpack_public_path__ + "img/comollegar.36e2d984.svg";